import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';


import { AnimatedLoader } from "./common/animated-loader/animated-loader";
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AnimatedLoader],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  private loadingService = inject(LoadingService);
  loading = signal(false);

  constructor() {
    this.loadingService.observable.subscribe((loading: boolean) => {
      this.loading.set(loading);
    });
  }

}
